import Application from '@ember/application';

export function initialize(application: Application): void {
  // Initialize ajax if needed
}

export default {
  name: 'ajax',
  initialize,
};
